import { ArrowRight, Check, Loader2, SlidersHorizontal } from 'lucide-react';

export default function CreationConfirmationBar({ decision, busy, creating, hasDraft, modes, onCreate, onChangeMode, onParameters, error, referenceCount = 0 }) {
  const mode = modes[decision?.mode];
  const carriesImages = decision.mode === 'canvas' && referenceCount > 0;
  return <footer className="home-intake__confirmation" aria-label="确认创作方案">
    {decision.mode === 'canvas' && <button type="button" className="home-intake__parameters" disabled={creating || busy || hasDraft} onClick={onParameters}><SlidersHorizontal size={14} />补充视频参数</button>}
    <div className="home-intake__mode-options" role="group" aria-label="创作方式">
      {Object.entries(modes).map(([key, value]) => <button type="button" key={key} aria-pressed={decision.mode === key} disabled={creating || hasDraft} onClick={() => onChangeMode(key)}><value.Icon size={14} />{value.label}{decision.mode === key && <Check size={12} />}</button>)}
    </div>
    <button type="button" className="home-intake__primary" disabled={!mode || creating || busy || hasDraft} onClick={onCreate}>
      {creating && <Loader2 size={15} className="home-intake__spin" />}
      {creating ? '正在带入需求…' : mode ? `确认并进入${mode.destination}` : '先选择创作方式'}
      {!creating && <ArrowRight size={15} />}
    </button>
    <p role="status">{creating ? carriesImages ? `正在带入方案、对话和 ${referenceCount} 张参考图…` : '正在创建项目并同步创作简报…'
      : hasDraft ? '先发送补充内容，我会更新这份方案。'
        : carriesImages ? `方案、对话和 ${referenceCount} 张参考图将一起带入画布上方的「首页创作参考」区域。`
          : '确认后，方案与对话会一起带入，未定细节可继续完善。'}</p>
    {error && <div className="home-intake__error" role="alert">{error}<button type="button" disabled={creating || hasDraft} onClick={onCreate}>重试创建</button></div>}
  </footer>;
}
